import React from 'react';
import { connect } from 'react-redux';
import { DBCheckBox, DBCheckBoxComment } from '_components';
import styles from './Common.module.css'

class SpeechOralPeripheralFeeding extends React.Component {

    render() {
        return (
            <div>
                <div className={styles.row}>
                <span className={styles.flag} />
                   <DBCheckBox
                        noteId={this.props.noteId}
                        entity='PTOBJECTIVESPEECH'
                        entityKeyColumn='OSNO'
                        entityKeyValue={this.props.osno}
                        field='OSORAWNL'
                        label='WNL'
                    />
                </div>
                <div className={styles.row}>
                    <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVESPEECH'
                         entityKeyColumn='OSNO'
                         entityKeyValue={this.props.osno}
                         field= 'OSORAOPENMOUTH'
                         className={styles.checkbox}
                         label='Open Mouth Posture'
                         textAreaStyle={styles.textAreaStyle}
                    />
                </div>
                <div className={styles.row}>
                    <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVESPEECH'
                         entityKeyColumn='OSNO'
                         entityKeyValue={this.props.osno}
                         field= 'OSORATONGUEPRO'
                         className={styles.checkbox}
                         label='Tongue Protrusion'
                         textAreaStyle={styles.textAreaStyle}
                    />
                </div>
                <div className={styles.row}>
                    <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVESPEECH'
                         entityKeyColumn='OSNO'
                         entityKeyValue={this.props.osno}
                         field= 'OSORADROOL'
                         className={styles.checkbox}
                         label='Drooling'
                         textAreaStyle={styles.textAreaStyle}
                    />
                </div>
                <div className={styles.row}>
                    <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVESPEECH'
                         entityKeyColumn='OSNO'
                         entityKeyValue={this.props.osno}
                         field= 'OSORATONGUEWEAK'
                         className={styles.checkbox}
                         label='Tongue Weakness'
                         textAreaStyle={styles.textAreaStyle}
                    />
                </div>
                <div className={styles.row}>
                    <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVESPEECH'
                         entityKeyColumn='OSNO'
                         entityKeyValue={this.props.osno}
                         field= 'OSORAJAWWEAK'
                         className={styles.checkbox}
                         label='Jaw Weakness'
                         textAreaStyle={styles.textAreaStyle}
                    />
                </div>
                <div className={styles.row}>
                    <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVESPEECH'
                         entityKeyColumn='OSNO'
                         entityKeyValue={this.props.osno}
                         field= 'OSORACHEW'
                         className={styles.checkbox}
                         label='Chewing Difficulty'
                         textAreaStyle={styles.textAreaStyle}
                    />
                </div>
                <div className={styles.row}>
                    <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVESPEECH'
                         entityKeyColumn='OSNO'
                         entityKeyValue={this.props.osno}
                         field= 'OSORAORALTACT'
                         className={styles.checkbox}
                         label='Oral-Tactile Defensive'
                         textAreaStyle={styles.textAreaStyle}
                    />
                </div>
                <div className={styles.row}>
                    <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVESPEECH'
                         entityKeyColumn='OSNO'
                         entityKeyValue={this.props.osno}
                         field= 'OSORATEXT'
                         className={styles.checkbox}
                         label='Textural Aversions'
                         textAreaStyle={styles.textAreaStyle}
                    />
                </div>
                <div className={styles.row}>
                    <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVESPEECH'
                         entityKeyColumn='OSNO'
                         entityKeyValue={this.props.osno}
                         field= 'OSORAFEED'
                         className={styles.checkbox}
                         label='Feeding Deficit'
                         textAreaStyle={styles.textAreaStyle}
                    />
                </div>
                <div className={styles.row}>
                    <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVESPEECH'
                         entityKeyColumn='OSNO'
                         entityKeyValue={this.props.osno}
                         field= 'OSORACLEFT'
                         className={styles.checkbox}
                         label='Cleft Lip/Palate'
                         textAreaStyle={styles.textAreaStyle}
                    />
                </div>
                <div className={styles.row}>
                    <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVESPEECH'
                         entityKeyColumn='OSNO'
                         entityKeyValue={this.props.osno}
                         field= 'OSORAANAT'
                         className={styles.checkbox}
                         label='Anatomical Abnormalities'
                         textAreaStyle={styles.textAreaStyle}
                    />
                </div>
                <div className={styles.row}>
                    <DBCheckBoxComment
                         noteId={this.props.noteId}
                         entity='PTOBJECTIVESPEECH'
                         entityKeyColumn='OSNO'
                         entityKeyValue={this.props.osno}
                         field= 'OSORAOTHER'
                         className={styles.checkbox}
                         label='Other'
                         textAreaStyle={styles.textAreaStyle}
                    />
                </div>
               
            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let osno = parseInt(Object.keys(state.entities.notes.PTOBJECTIVESPEECH)
    .find(key => (state.entities.notes.PTOBJECTIVESPEECH[key].OSEVNO === pk && noteType === 1)
        || (state.entities.notes.PTOBJECTIVESPEECH[key].OSNTNO === pk && noteType !== 1)));
        
    return {
        noteId: noteId,
        osno: osno,
    };
}

const connectedSpeechOralPeripheralFeeding = connect(mapStateToProps)(SpeechOralPeripheralFeeding);
export { connectedSpeechOralPeripheralFeeding as SpeechOralPeripheralFeeding };


